<!--
* UIID: UI-DLB-MIG-100
* UI Name: MIG List
* Modify Date: 2020/08/11
-->
<template>
  <div class="container">
    <!-- Header -->
    <v-row class="page-header">
      <v-col class="page-title" cols="12">
        <v-toolbar-title class="font-bold">{{
          $t('lbl.referenceFiles.page_header')
        }}</v-toolbar-title>
      </v-col>
    </v-row>
    <!-- Condition search -->
    <!-- 2021.07.28 163189 SPKA-168 change layout like TRANSACTION LOG -->
    <v-row class="custom-form-control custom-figma-1">
      <v-col cols="12" class="search-conditions-display">
        <div class="pl-0 pt-0 pb-0 collapse-search-conditions hide">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('collapse')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-up</v-icon>
            {{ $t('btn.common.collapseConditions') }}
          </v-btn>
        </div>
        <div class="pl-0 pt-0 pb-0 expand-search-conditions">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('expand')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-down</v-icon>
            {{ $t('btn.common.expandConditions') }}
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12" class="pt-0 pb-0">
        <v-row>
          <v-col
            class="comm-header-col data-query-section pb-0 pt-0 mt-0 custom-figma-1"
            cols="12"
            lg="5"
            md="5"
          >
            <v-row>
              <!-- 203705_MIG(UI-DLB-RF-100)_Fix issues 1,2 -->
              <v-col cols="12" md="6" class="pt-0 pb-0">
                <v-text-field
                  v-model="masterSearchItems.data[0].FILE_NAME"
                  @keyup.enter="queryList"
                  :label="$t('lbl.common.conditionSearch.findbyFileName')"
                  class="custom-selectbox"
                  height="30"
                  hide-details
                  dense
                  filled
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="pt-0 pb-0 pr-24px">
                <v-select
                  v-model="masterSearchItems.data[0].FRMT_TP"
                  :label="$t('lbl.common.conditionSearch.selectDocumentType')"
                  :items="codeItem"
                  @change="queryList"
                  class="custom-selectbox"
                  height="30"
                  hide-details
                  dense
                  filled
                ></v-select>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            class="comm-header-col date-query-section pb-0 pt-0 pr-0 mt-0 text-right custom-figma-1"
            cols="12"
            lg="7"
            md="7"
          >
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <!-- 203737 SPKA-49 issue 5 apply date conndition -->
              <!-- <v-label>{{$t('lbl.referenceFiles.updateDate')}}</v-label> -->
              <v-autocomplete
                v-model="masterSearchItems.init.DAT_TYPE"
                :label="$t('lbl.common.conditionSearch.dateType')"
                :items="dateTypes"
                :menu-props="{ offsetY: true }"
                @change="changeDtTp"
                class="custom-selectbox"
                hide-details
                dense
                solo
              ></v-autocomplete>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-menu
                v-model="fromdate_menu"
                :close-on-content-click="false"
                ref="fromdate_menu"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="masterSearchItems.init.FR_DAT"
                    :placeholder="' '"
                    :disabled="
                      masterSearchItems.init.DAT_TYPE == undefined ||
                        masterSearchItems.init.DAT_TYPE == null ||
                        masterSearchItems.init.DAT_TYPE == ''
                    "
                    :error-messages="masterSearchItems.init.FR_DAT_ERROR"
                    :class="['date-text', $vuetify.theme.dark ? '' : 'font-semibold']"
                    append-icon="mdi-calendar"
                    dense
                    solo
                    @keypress="formatDate('from', $event)"
                    @change="changeDate('from')"
                    @click:append="on.click"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="masterSearchItems.init.FR_DAT"
                  :max="getMaxDate"
                  @input="
                    fromdate_menu = false;
                    changeDate('from');
                  "
                  class="date-period-picker"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="fromdate_menu = false">{{
                    $t('btn.common.cancel')
                  }}</v-btn>
                  <v-btn
                    @click="$refs.fromdate_menu.save(masterSearchItems.init.FR_DAT)"
                    text
                    color="primary"
                    >{{ $t('btn.common.ok') }}</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-menu
                v-model="todate_menu"
                :close-on-content-click="false"
                ref="todate_menu"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="masterSearchItems.init.TO_DAT"
                    :error-messages="masterSearchItems.init.TO_DAT_ERROR"
                    :placeholder="' '"
                    :disabled="
                      masterSearchItems.init.DAT_TYPE == undefined ||
                        masterSearchItems.init.DAT_TYPE == null ||
                        masterSearchItems.init.DAT_TYPE == ''
                    "
                    :class="['date-text', $vuetify.theme.dark ? '' : 'font-semibold']"
                    append-icon="mdi-calendar"
                    dense
                    solo
                    @keypress="formatDate('to', $event)"
                    @change="changeDate('to')"
                    @click:append="on.click"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="masterSearchItems.init.TO_DAT"
                  :allowed-dates="allowedDates"
                  @input="
                    todate_menu = false;
                    changeDate('to');
                  "
                  class="date-period-picker"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="todate_menu = false">{{
                    $t('btn.common.cancel')
                  }}</v-btn>
                  <v-btn
                    @click="$refs.todate_menu.save(masterSearchItems.init.TO_DAT)"
                    text
                    color="primary"
                    >{{ $t('btn.common.ok') }}</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-btn
                class="btn btn-top btn-search btn-width-1"
                color="primary"
                @click.native="queryList"
              >
                <v-icon x-small class="mr-2">fa fa-search</v-icon>{{ $t('btn.common.search') }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- // 2021.11.24 203728 SPKA-274 modify paging -->
    <!-- Grid table page class="flat-file-control-section" -->
    <v-row class="custom-pagination-figma-v3-first">
      <v-col class="page-control-content page-control-bg">
        <v-row>
          <v-col lg="6" md="6">
            <v-row>
              <v-col class="page-control-bg" cols="12">
                <v-btn
                  class="btn btn-add"
                  :disabled="!$auth.manage"
                  @click="openAddReferenceFileDialog"
                >
                  {{ $t('btn.common.add') }}
                </v-btn>
                <v-tooltip
                  top
                  :disabled="!isEnableDelete || !$auth.manage"
                  :max-width="tooltipWidth"
                >
                  <template v-slot:activator="{ on }">
                    <div v-on="on" class="btn-tooltip">
                      <v-btn
                        class="btn btn-delete"
                        color="#cd5f5f"
                        @click="deleteReference"
                        :disabled="isEnableDelete || !$auth.manage"
                      >
                        {{ $t('btn.common.delete') }}
                      </v-btn>
                    </div>
                  </template>
                  <span>{{ $t('msg.customerDataAnalysis.deleteTooltipMsg') }}</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-col>
          <v-col lg="2" md="1"> </v-col>
          <v-col lg="4" md="5" class="filter-search">
            <v-row>
              <v-col class="mr-0 pr-0" md="5">
                <v-select
                  v-model="searchBy"
                  :placeholder="$t('lbl.common.searchTypePlaceHolder')"
                  :items="searchByItems"
                  @change="onFilterReferenceFiles"
                  class="search-by data-table-select-box custom-selectbox flat-file-selectbox mr-0"
                  height="30"
                  hide-details
                  dense
                  solo
                ></v-select>
              </v-col>
              <v-col class="ml-0 pl-0" cols="12" md="7">
                <v-text-field
                  v-model="search"
                  @keyup.enter="onFilterReferenceFiles"
                  @input="onFilterReferenceFiles"
                  @click:append="onFilterReferenceFiles"
                  :placeholder="$t('lbl.common.searchPlaceHolder')"
                  class="data-table-filter-text-field search-button-data-analysis-table flat-file"
                  heigth="30"
                  append-icon="fa fa-search"
                  hide-details
                  dense
                  solo
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- Grid table List -->
    <v-row>
      <!-- // 2021.5.19 203728 Issue 53 No display spinner -->
      <!-- 2021.12.8 203728 SPKA-305 show bottom border -->
      <system-progress :sysloading="isLoading" :sysloadingTitle="sysloadingTitle"></system-progress>
      <v-col cols="12" class="pt-0 pb-0">
        <v-data-table
          v-model="selectMasterRows"
          :headers="table_header"
          :items="mainGrid"
          :hide-default-footer="true"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :fixed-header="true"
          :height="tableHeight"
          @page-count="pageCount = $event"
          :class="[
            'list-table map-manager-list-table srm-list-table custom-border-table',
            mainGrid.length > 0 ? '' : 'custom-border-table-not-data',
          ]"
          item-key="ROWID"
          :sort-desc="true"
          sort-by="ATF_UPD_DT"
          pb-2
        >
          <template v-slot:header.checkbox="{ header }">
            <v-checkbox
              @change="selectAllChange"
              class="select-checkbox-layout-table align-center justify-center flat-file-checkbox"
              color="#dbd7db"
              dense
              hide-details
            ></v-checkbox>
          </template>
          <template v-slot:body="{ items }">
            <tbody>
              <tr
                v-for="item in items"
                :key="item.ROWID"
                @click="onClickRow(item)"
                :class="[selectedRow === item.ROWID ? 'selected_row' : '']"
              >
                <td class="checkbox-col">
                  <v-checkbox
                    v-model="item.checked"
                    @click.native="selectItemChange($event, item)"
                    @click.native.stop
                    id="item.checked"
                    class="select-checkbox-layout-table align-center justify-center flat-file-checkbox"
                    color="#dbd7db"
                    dense
                    hide-details
                  ></v-checkbox>
                </td>
                <td class="type-col">
                  <a class="link-file-text" @click="openModifyReferenceFile(item)">{{
                    item.ATF_FILE_NAME
                  }}</a>
                </td>
                <td class="type-col text-center">{{ item.ATF_FRMT_TP_NM }}</td>
                <td class="type-col">{{ item.ATF_CHKIN_COMT }}</td>
                <td class="date-col text-center">{{ item.ATF_UPD_DT }}</td>
                <td class="update-user-col">{{ item.ATF_UPD_USR }}</td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <!-- // 2021.11.24 203728 SPKA-274 modify paging  -->
    <v-row v-show="mainGrid.length > 0" class="custom-pagination-figma-v3-last">
      <v-col class="page-control-content page-control-bg transaction-pagi">
        <v-row>
          <v-col lg="12" md="12">
            <v-row>
              <v-col class="page-control-bg text-left pa-0" cols="6">
                <div class="custom-pagi-selectbox">
                  <v-select
                    v-model="itemsPerPage"
                    :items="itemShow"
                    class="data-table-select-box custom-selectbox mr-0 page-flat-file-selectbox"
                    hide-details
                    dense
                    solo
                  ></v-select>
                </div>
              </v-col>
              <v-col class="page-control-bg text-right pa-0" cols="6">
                <div class="page-showing">
                  <v-label>
                    {{ itemsPerPage * (page - 1) + 1 }} ~
                    {{
                      mainGrid.length - itemsPerPage * page > 0
                        ? itemsPerPage * page
                        : mainGrid.length
                    }}
                    of {{ mainGrid.length }}
                  </v-label>
                </div>
                <!-- 2021.11.23 203728 SPKA-260 first prev button -->
                <button
                  type="button"
                  @click="page = 1"
                  :class="[
                    'custom-btn-first-last-paging',
                    page == 1 ? ' v-pagination__navigation--disabled' : '',
                  ]"
                >
                  <div class="ml-2 pr-2 d-inline">
                    <span><i class="fa fa-sm fa-step-backward"></i></span>
                  </div>
                </button>
                <button
                  type="button"
                  @click="changePageByTextbox(-1)"
                  :class="[
                    'mr-3 custom-btn-first-last-paging',
                    page - 1 < 1 ? ' v-pagination__navigation--disabled' : '',
                  ]"
                >
                  <div class="ml-2 pr-2 d-inline">
                    <span><i class="fa fa-lg fa-caret-left"></i></span>
                  </div>
                </button>
                <v-text-field
                  v-model="pageEnter"
                  hide-details
                  dense
                  solo
                  class="data-table-filter-text-field custom-pagi-selectbox page-selectbox"
                  @keyup.enter="changePageByTextbox(0)"
                ></v-text-field
                ><label>/ {{ pageCount }}</label>
                <button
                  type="button"
                  @click="changePageByTextbox(1)"
                  :class="[
                    'ml-3 custom-btn-first-last-paging',
                    page + 1 > pageCount ? ' v-pagination__navigation--disabled' : '',
                  ]"
                >
                  <div class="mr-2 pl-2 d-inline">
                    <span><i class="fa fa-lg fa-caret-right"></i></span>
                  </div>
                </button>
                <button
                  type="button"
                  @click="page = pageCount"
                  :class="[
                    'custom-btn-first-last-paging',
                    page == pageCount ? ' v-pagination__navigation--disabled' : '',
                  ]"
                >
                  <div class="mr-2 pl-2 d-inline">
                    <span><i class="fa fa-sm fa-step-forward"></i></span>
                  </div>
                </button>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <div v-for="dialog in dialogs" :key="dialog.id" class="dialogs">
      <addReferenceFile
        v-if="dialog.type == 'addReferenceFile'"
        :id="dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        @reloadPage="queryList"
        class="custom-dialog mapper-version"
        ref="addReferenceFile"
      ></addReferenceFile>
    </div>
    <dialogWindow
      ref="SearchCondition"
      size="max"
      title="Search"
      :detail="$t('msg.common.fromDateValidate')"
      color="validation"
    ></dialogWindow>
    <dialogWindow
      ref="warningDialog"
      size="max"
      title="Warning"
      color="validation"
      :detail="$t('msg.common.noSelectItem')"
    ></dialogWindow>
    <dialogWindow
      ref="deleteSuccesssDialog"
      size="max"
      title="Delete Success"
      color="success"
      :detail="$t('msg.referenceFiles.deleteSuccess')"
      @select-ok="queryList"
    ></dialogWindow>

    <dialogWindow
      ref="deleteDialog"
      size="max"
      title="Delete Reference Files"
      :show-cancel="true"
      :detail="$t('msg.common.infoConfirm.detail', ['delete the selected items'])"
      color="confirmation"
      @select-ok="onDeleteReferenceFiles"
    ></dialogWindow>
    <dialogWindow
      ref="validateDate"
      size="max"
      :detail="$t('msg.common.validateDate')"
      color="validation"
    ></dialogWindow>
  </div>
</template>

<script>
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import { mapState } from 'vuex';
import $ from 'jquery';
import { deleteDateFormatStr } from '@/vue-dlb/utils/util';
import { beforeOneMonth } from '@/vue-dlb/utils/util';
import { getAppliedTimeZone } from '@/vue-dlb/utils/util';
import { dateValidation } from '@/vue-dlb/utils/util';

import addReferenceFile from '@/vue-dlb/views/referencefile/AddReferenceFile.vue';
import cfg from '@/vue-caas/config/config.js';
import { resizeTableHeight } from '@/vue-dlb/common/common';

// 2021.5.19 203728 Issue 53
import SystemProgress from '@/vue-dlb/components/SystemProgress.vue';

export default {
  components: {
    dialogWindow,
    addReferenceFile,
    // 2021.5.19 203728 Issue 53
    SystemProgress,
  },

  computed: {
    ...mapState('common', {
      codeList: 'codeList',
      repomenuMode: 'repomenuMode',
      ysloading: 'sysloading',
      sysloadingTitle: 'sysloadingTitle',
    }),
    ...mapState('referencefile', {
      mainGrid: 'mainGrid',
    }),
    // 203728 SPKA-49 issue 5 apply date conndition
    getMaxDate() {
      if (
        dateValidation(
          deleteDateFormatStr(this.masterSearchItems.init.FR_DAT),
          deleteDateFormatStr(this.masterSearchItems.init.TO_DAT),
        )
      ) {
        return getAppliedTimeZone();
      } else {
        this.$refs.SearchCondition.dialog = true;
        return getAppliedTimeZone();
      }
    },
    getMinDate() {
      if (
        dateValidation(
          deleteDateFormatStr(this.masterSearchItems.init.FR_DAT),
          deleteDateFormatStr(this.masterSearchItems.init.TO_DAT),
        )
      ) {
        return this.masterSearchItems.init.FR_DAT;
      } else {
        this.$refs.SearchCondition.dialog = true;
        return this.masterSearchItems.init.FR_DAT;
      }
    },
    isEnableDelete() {
      if (this.selectMasterRows.length > 0) {
        return false;
      }
      return true;
    },
  },
  data() {
    return {
      ACCESS_REPO_YN: '', // common mandatory for ADMIN_YN
      dateTimeFormat: '',
      fromdate_menu: false,
      maximumItem: 4,
      todate_menu: false,
      page: 1,
      itemsPerPage: 100,
      pageCount: 0,
      pageEnter: 1, // 2021.11.24 203728 SPKA-274 modify paging
      search: '',
      tooltipWidth: 300,
      isCreated: false,
      tableHeight: '',
      itemShow: [
        { text: 'Show 10', value: 10 },
        { text: 'Show 25', value: 25 },
        { text: 'Show 50', value: 50 },
        { text: 'Show 75', value: 75 },
        { text: 'Show 100', value: 100 },
      ],
      table_header: [
        { text: '', value: 'checkbox', sortable: false, width: '2%' },
        {
          text: this.$t('tbl.referenceFiles.header_fileName'),
          value: 'ATF_FILE_NAME',
          'min-width': '400px',
        },
        {
          text: this.$t('tbl.referenceFiles.header_docType'),
          value: 'ATF_FRMT_TP_NM',
          width: '160px',
        },
        {
          text: this.$t('tbl.referenceFiles.header_comment'),
          value: 'ATF_CHKIN_COMT',
          width: '550px',
        },
        {
          text: this.$t('tbl.referenceFiles.header_updateDate'),
          value: 'ATF_UPD_DT',
          width: '130px',
        },
        {
          text: this.$t('tbl.referenceFiles.header_updateUser'),
          value: 'ATF_UPD_USR',
          width: '152px',
        },
      ],
      deleteDataParams: {
        header: ['ATF_PRCS_NO', 'FILE_ID'],
        data: [],
      },
      codeSearchItems: {
        header: ['GRP_CODE'],
        data: [
          {
            GRP_CODE: '',
          },
        ],
      },
      MIGFileDownloadItems: {
        header: ['FILE_ID', 'SAVE_NAME'],
        data: [
          {
            FILE_ID: '',
            SAVE_NAME: '',
          },
        ],
      },
      // 203737 SPKA-49 issue 5 apply date conndition
      masterSearchItems: {
        header: [
          'ADMIN_YN',
          'CUST_ID',
          'OWNR_CUST_ID',
          'FILE_NAME',
          'FRMT_TP',
          'DAT_TYPE',
          'FR_DAT',
          'TO_DAT',
        ],
        data: [
          {
            ADMIN_YN: '',
            CUST_ID: '',
            OWNR_CUST_ID: '',
            FILE_NAME: '',
            FRMT_TP: '',
            DAT_TYPE: '',
            FR_DAT: '',
            TO_DAT: '',
          },
        ],
        init: {
          // 203728 SPKA-49 issue 5 apply date conndition
          FR_DAT: beforeOneMonth(),
          TO_DAT: getAppliedTimeZone(),
          FR_DAT_PREV: beforeOneMonth(),
          TO_DAT_PREV: getAppliedTimeZone(),
          FR_DAT_ERROR: [],
          TO_DAT_ERROR: [],
          DAT_TYPE: '',
        },
      },
      dateTypes: [
        { value: '', text: 'Search by' },
        { value: 'UPDT', text: 'Update Date' },
      ],
      codeItem: [{ text: this.$t('lbl.common.conditionSearch.all'), value: '' }],
      selectMasterRows: [],
      searchBy: 'all',
      searchByItems: [
        { text: this.$t('lbl.referenceFiles.searchText.searchAll'), value: 'all' },
        { text: this.$t('lbl.referenceFiles.searchText.fileName'), value: 'ATF_FILE_NAME' },
        { text: this.$t('lbl.referenceFiles.searchText.docType'), value: 'ATF_FRMT_TP_NM' },
        { text: this.$t('lbl.referenceFiles.searchText.comment'), value: 'ATF_CHKIN_COMT' },
        { text: this.$t('lbl.referenceFiles.searchText.updateDate'), value: 'ATF_UPD_DT' },
        { text: this.$t('lbl.referenceFiles.searchText.updateUser'), value: 'ATF_UPD_USR' },
      ],
      arrLayoutDialog: [],
      dialogs: [],
      dialogId: 1,
      selected: null,
      // 2021.5.19 203728 Issue 53
      isLoading: false,
      selectedRow: '',
    };
  },
  watch: {
    // 2021.11.24 203728 SPKA-274 modify paging
    page() {
      this.pageEnter = this.page;
    },
  },
  methods: {
    displaySearchConditions(action) {
      if (action === 'expand') {
        $('.date-query-section').css('display', 'block');
        $('.data-query-section').css('display', 'block');
        $('.expand-search-conditions').css('display', 'none');
        $('.collapse-search-conditions').css('display', 'block');
      } else {
        $('.date-query-section').css('display', 'none');
        $('.data-query-section').css('display', 'none');
        $('.expand-search-conditions').css('display', 'block');
        $('.collapse-search-conditions').css('display', 'none');
      }
    },
    validateDateInput(dateString) {
      var regEx = /^\d{4}-\d{2}-\d{2}$/;
      if (!dateString.match(regEx)) return false; // Invalid format
      var d = new Date(dateString);
      var dNum = d.getTime();
      if (!dNum && dNum !== 0) return false; // NaN value, Invalid date
      return d.toISOString().slice(0, 10) === dateString;
    },
    formatDate(side, evt) {
      let dateString =
        side === 'from' ? this.masterSearchItems.init.FR_DAT : this.masterSearchItems.init.TO_DAT;
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46 && charCode !== 45) {
        evt.preventDefault();
      } else if (
        (charCode !== 46 &&
          charCode !== 8 &&
          charCode !== 45 &&
          dateString.length === 4 &&
          !dateString.includes('-')) ||
        (charCode !== 46 &&
          charCode !== 8 &&
          charCode !== 45 &&
          dateString.length === 7 &&
          dateString[4] === '-' &&
          (dateString.match(/-/g) || []).length == 1)
      ) {
        dateString += '-';
        side === 'from'
          ? (this.masterSearchItems.init.FR_DAT = dateString)
          : (this.masterSearchItems.init.TO_DAT = dateString);
      } else {
        return true;
      }
    },
    changeDate(side) {
      if (side === 'from') {
        if (!this.validateDateInput(this.masterSearchItems.init.FR_DAT)) {
          this.$refs.validateDate.dialog = true;
          this.masterSearchItems.init.FR_DAT = getAppliedTimeZone();
          this.masterSearchItems.init.TO_DAT = getAppliedTimeZone();
          return;
        }
        if (this.masterSearchItems.init.FR_DAT > getAppliedTimeZone()) {
          this.masterSearchItems.init.FR_DAT = getAppliedTimeZone();
        }
        if (this.masterSearchItems.init.FR_DAT > this.masterSearchItems.init.TO_DAT) {
          this.masterSearchItems.init.TO_DAT = this.masterSearchItems.init.FR_DAT;
        }
      }
      if (side === 'to') {
        if (!this.validateDateInput(this.masterSearchItems.init.TO_DAT)) {
          this.$refs.validateDate.dialog = true;
          this.masterSearchItems.init.TO_DAT = getAppliedTimeZone();
          this.masterSearchItems.init.FR_DAT = getAppliedTimeZone();
          return;
        }
        if (this.masterSearchItems.init.TO_DAT > getAppliedTimeZone()) {
          this.masterSearchItems.init.TO_DAT = getAppliedTimeZone();
        }
        if (this.masterSearchItems.init.FR_DAT > this.masterSearchItems.init.TO_DAT) {
          this.masterSearchItems.init.FR_DAT = this.masterSearchItems.init.TO_DAT;
        }
      }
    },
    onClickRow(item) {
      this.selectedRow = item.ROWID;
    },
    // 2021.11.24 203728 SPKA-274 process change page by input textbox
    changePageByTextbox(value) {
      let data = parseInt(this.pageEnter);
      if (isNaN(data)) {
        this.pageEnter = this.page;
        return;
      } else {
        this.page = data > this.pageCount ? this.pageCount : data < 1 ? 1 : data;
        this.pageEnter = this.page;
      }
      this.page += value;
    },
    // 203728 SPKA-49 issue 5 apply date conndition
    changeDtTp() {
      if (
        this.masterSearchItems.init.DAT_TYPE == undefined ||
        this.masterSearchItems.init.DAT_TYPE == null ||
        this.masterSearchItems.init.DAT_TYPE == ''
      ) {
        this.masterSearchItems.init.FR_DAT = '';
        this.masterSearchItems.init.TO_DAT = '';
      } else {
        this.masterSearchItems.init.FR_DAT = this.masterSearchItems.init.FR_DAT || beforeOneMonth();
        this.masterSearchItems.init.TO_DAT =
          this.masterSearchItems.init.TO_DAT || getAppliedTimeZone();
      }
    },

    getFRMT() {
      this.codeSearchItems.data[0].GRP_CODE = 'B05';
      Store.dispatch('common/getCode', this.codeSearchItems).then(() => {
        console.log('--------- Finished to process code List ----------');
        console.log(this.codeList);
        for (let i = 0; i < this.codeList.length; i++) {
          let codeObj = {};
          codeObj.text = this.codeList[i].CM_CODE_NAME;
          codeObj.value = this.codeList[i].CM_CODE_ID;
          this.codeItem.push(codeObj);
        }
      });
    },
    queryList() {
      // 203728 SPKA-49 issue 5 apply date conndition
      if (
        dateValidation(
          deleteDateFormatStr(this.masterSearchItems.init.FR_DAT),
          deleteDateFormatStr(this.masterSearchItems.init.TO_DAT),
        )
      ) {
        // 2021.5.19 203728 Issue 53
        this.isLoading = true;
        console.log('--------- getSummaryList ----------');
        console.log('before fromdate(' + this.masterSearchItems.init.FR_DAT + ')');
        this.masterSearchItems.data[0].FR_DAT = deleteDateFormatStr(
          this.masterSearchItems.init.FR_DAT,
        );
        console.log('after fromdate(' + this.masterSearchItems.data[0].FR_DAT + ')');
        this.masterSearchItems.data[0].TO_DAT = deleteDateFormatStr(
          this.masterSearchItems.init.TO_DAT,
        );
        this.masterSearchItems.data[0].CUST_ID = $cookies.get('comp-id');
        this.masterSearchItems.data[0].OWNR_CUST_ID = $cookies.get('ownr-id');
        this.masterSearchItems.data[0].ADMIN_YN = this.ACCESS_REPO_YN;
        this.masterSearchItems.data[0].DAT_TYPE = this.masterSearchItems.init.DAT_TYPE;
        Store.dispatch('referencefile/queryList', this.masterSearchItems)
          .then(() => {
            console.log('--------- Finished to process mainGrid----------');
            console.log(this.mainGrid);
            // 2021.5.19 203728 Issue 53
            this.isLoading = false;
          })
          .catch((ex) => {
            // 2021.5.19 203728 Issue 53
            this.isLoading = false;
          });
      } else {
        this.$refs.SearchCondition.dialog = true;
      }
    },
    onFilterReferenceFiles(str) {
      Store.commit('referencefile/SET_REFERENCS_FILTER', {
        filter: this.searchBy,
        str: this.search,
      });
    },
    deleteReference() {
      if (this.selectMasterRows.length === 0) {
        this.$refs.warningDialog.dialog = true;
      }
      if (this.selectMasterRows.length > 0) {
        this.$refs.deleteDialog.dialog = true;
      }
    },
    onDeleteReferenceFiles() {
      if (this.selectMasterRows.length > 0) {
        for (var i = 0; i < this.selectMasterRows.length; i++) {
          this.deleteDataParams.data[i] = {
            ATF_PRCS_NO: `${this.selectMasterRows[i].ATF_PRCS_NO}`,
            FILE_ID: `${this.selectMasterRows[i].FILE_ID}`,
          };
        }
        Store.dispatch('referencefile/deleteReferenceFiles', this.deleteDataParams).then(() => {
          this.$refs.deleteSuccesssDialog.dialog = true;
        });
      }
      this.selectMasterRows = [];
    },
    openAddReferenceFileDialog() {
      let type = 'addReferenceFile';
      let item = {
        ROWID: 0,
        action: 'add',
        codeItem: this.codeItem,
      };
      let indexArrDialog = this.findDialog('addReferenceFile_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openModifyReferenceFile(rowItem) {
      let type = 'addReferenceFile';
      let item = {
        ROWID: 0,
        action: 'modify',
        data: rowItem,
      };
      let indexArrDialog = this.findDialog('addReferenceFile_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    findDialog(id, dialogs) {
      if (!dialogs) dialogs = this.dialogs;
      let index = dialogs.findIndex((val) => {
        return val.id === id;
      });
      return index > -1 ? index : null;
    },
    newDialog(item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },
    generateDialog(item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({ id: id });
      this.dialogId++;
      let name = 'Dialog ' + id;
      let options = { left: 30 * this.dialogId, top: 30 * this.dialogId, item };
      return { id, name, type, options };
    },
    removeDialog(dialog) {
      let id = dialog.id;
      let index = this.findDialog(id);
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1);
      if (this.selected && this.selected.id === id) this.selected = null;
    },
    dialogDragEnd(obj) {
      let index = this.findDialog(obj.id);
      this.$set(this.dialogs[index].options, 'left', obj.left);
      this.$set(this.dialogs[index].options, 'top', obj.top);
    },
    selectDialog(obj) {
      let index = this.findDialog(obj.id);
      this.selected = this.dialogs[index];
    },
    selectAllChange(value) {
      let selectAllItems = [];
      if (value) {
        for (let i = 0; i < this.mainGrid.length; i++) {
          let item = this.mainGrid[i];
          item.checked = value;
          selectAllItems.push(item);
        }
        this.selectMasterRows = selectAllItems;
      } else {
        for (let i = 0; i < this.mainGrid.length; i++) {
          let item = this.mainGrid[i];
          item.checked = false;
        }
        this.selectMasterRows = [];
      }
    },
    selectItemChange(event, item) {
      let maxItem = this.maximumItem;
      let checked = item.checked;
      if (checked == true) {
        this.selectMasterRows.push(item);
      } else if (checked == false) {
        let index = this.findIndexItem(item, this.selectMasterRows, 'ROWID');
        if (index != null) {
          this.selectMasterRows.splice(index, 1);
        }
      }
    },
    findIndexItem(item, arr, col) {
      let prop = typeof col == 'undefined' ? 'id' : col;
      let index = arr.findIndex((row) => {
        return row[prop] === item[prop];
      });
      return index > -1 ? index : null;
    },
    allowedDates(val) {
      let date = getAppliedTimeZone();
      if (val <= date) {
        return val;
      }
    },
  },
  created() {
    if (this.repomenuMode) {
      // Repository Menu
      if ($cookies.get('login-user-comp-id') == cfg.provider) this.ACCESS_REPO_YN = 'NY';
      // CLT Super Provider
      else this.ACCESS_REPO_YN = 'YN'; // Normal User Admin
    } else {
      // Normal User
      this.ACCESS_REPO_YN = 'NN';
    }
    this.dateTimeFormat = cfg.dateTimeFormat;
    this.tooltipWidth = cfg.tooltipWidth;
    this.changeDtTp();
    this.queryList();
    this.getFRMT();
    this.isCreated = true;
  },
  // 2021.11.24 203728 SPKA-274 modify paging
  updated: function() {
    let self = this;
    let arrClassMinus = ['.page-control-content'];
    let arrClassPlus = [];

    if (this.isCreated) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 + 'px';
      this.isCreated = false;
    }

    $(window).resize(function(event) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 + 'px';
    });
  },
  mounted() {},
};
</script>
